
export const manufacturerModel = ({
                                      manufacturerId,
                                      name,
                                  }: Record<string, any> = {}) => ({
    manufacturerId,
    name,
});

export const emptyManufacturerModel = manufacturerModel();